import React, {Component, useState} from 'react';
import {Switch, Route, Redirect, useHistory} from 'react-router-dom';
import {withRouter} from 'react-router';

import './App.css';
// import './shared/FontawesomeIcons/index';

import HomePage from './pages/HomePage/HomePage';
import Header from './components/Header/Header';
import SideDrawer from './components/SideDrawer/SideDrawer';
import BackDrop from './components/BackDrop/Backdrop';
import Signin from './pages/Signin/Signin';
import Register from './pages/Register/Register';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import Feed from './pages/Feed/Feed';
import FeedHeader from './components/FeedHeader/FeedHeader';
import Footer from './components/Footer/Footer';

import oktaConfig from './oidc/test.oidc';
import {Security, SecureRoute, LoginCallback} from '@okta/okta-react';


export default function App(props) {
	const [sideDrawerOpen, toggleSideDrawerOpen] = useState();
	const history = useHistory();

	const drawerToggleClickHandler = () => {
		toggleSideDrawerOpen(!sideDrawerOpen);
	};

	const backdropClickHandler = () => {
		toggleSideDrawerOpen(false);
	};

	const onAuthRequired = () => {
		history.push('/signin');
	};

	let backdrop;

	if (sideDrawerOpen) {
		// sideDrawer = <SideDrawer />
		backdrop = <BackDrop click={backdropClickHandler}/>
	}

	return (
		<div className="page-container">
			<div className="content-wrap">
				<SideDrawer show={sideDrawerOpen}/>
				{backdrop}
				<Security
					{...oktaConfig.oidc}
					onAuthRequired={onAuthRequired}
				>
					{/* <Link to="/topics">Topics</Link> */}
					{/* <button onClick={()=> props.history.push('/topics')}>Topics</button> */}
					<Route exact={true} path="/">
						<Header drawerToggleClickHandler={drawerToggleClickHandler}/>
						<HomePage/>
						<Footer/>
					</Route>
					<Route exact={true} path="/signin">
						<Signin/>
					</Route>
					<Route exact={true} path="/register">
						<Register/>
					</Route>
					<Route exact={true} path="/forgot-password">
						<ForgotPassword/>
					</Route>
					<Route exact={true} path="/feed">
						<FeedHeader/>
						<Feed/>
					</Route>
					<Route exact={true} path="/match">
						<FeedHeader/>
						<Footer/>
					</Route>
					<Route exact={true} path="/profile">
						<FeedHeader/>
						<Footer/> 
					</Route>
					<Route exact={true} path="/accountseting">
						<FeedHeader/>
						<Footer/> 
					</Route>
					{/* <Route path="/topics/:topicId" component={TopicDetail}/> */}
					<SecureRoute path="/test" component={() => (<div>Logged in</div>)} />
					<Route path='/implicit/callback' exact={true} component={LoginCallback} />
				</Security>
			</div>
		</div>
	);
}
